import { useContext, useEffect, useState } from "react";

import { useNavigate, useParams, Link } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { ToastContext } from "../Components/ToastProvider";

function ConfirmingEmail(id) {
  const { token } = useParams();

  const { confirmEmail } = useAuth();

  const { createToast } = useContext(ToastContext);

  const navigate = useNavigate();

  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (loaded) {
      return;
    }

    confirmEmail(token).then(async (success) => {
      if (success) {
        createToast(
          "You have confirmed your email address.  Now you can log in.",
          "success",
        );
        navigate("/login");
        setLoaded(true);
      } else {
        setError(true);
        setLoaded(true);
      }
    });
  }, [confirmEmail, createToast, navigate, token, loaded]);

  if (!loaded) {
    return <></>;
  }
  return (
    <div>
      {!error ? (
        <>
          <h1>Thanks for confirming your email.</h1>
          <p>You will now be redirected to login.</p>
        </>
      ) : (
        <>
          <h1>Your email confirmation link may have expired</h1>
          <p>Good news: getting a new one takes about 2 seconds.</p>
          <p className="margin-t-40 underline">
            <Link to="/resend-email-confirm">
              Request New Confirmation Email
            </Link>
          </p>
        </>
      )}
    </div>
  );
}

export default ConfirmingEmail;
